import { render, staticRenderFns } from "./newCalendar.vue?vue&type=template&id=2fe1e882&"
import script from "./newCalendar.vue?vue&type=script&lang=js&"
export * from "./newCalendar.vue?vue&type=script&lang=js&"
import style0 from "./newCalendar.vue?vue&type=style&index=0&id=2fe1e882&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports